// src/main.tsx
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { initializeAuth } from './app/auth/authInitializer';

initializeAuth();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element "#root" was not found in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
